export default __webpack_public_path__ + "static/media/search-ready.634c4deb.gif";